<div provide-parent-form>
	<div class="main-container">
		<!-- name -->
		<mat-form-field appearance="fill" class="full-width">
			<mat-label>{{'CHANNEL_NAME' | translate}}</mat-label>
			<input required [(ngModel)]="channel.name" matInput name="channel_name"
				(ngModelChange)="validateNameUnique(channel.name)">
			<mat-error>
				<ng-container *ngIf="!channel.name">{{ 'FIELD_IS_REQUIRED' | translate }}</ng-container>
				<ng-container *ngIf="channel.name">{{ 'VIOLATION_UNIQUE_CONSTRAINT_FIELD' | translate }}</ng-container>
			</mat-error>
		</mat-form-field>

		<h3>{{ 'STYLING' | translate }}</h3>
		<!-- colorTheme -->
		<div class="channel-group-block">
			<bb-form-element [form]="form" [required]="true" theme="light-v2" [label]="'COLOR_THEME' | translate"
				labelIcon="circle-half-stroke fas" [hideRequiredMark]="true">
				<bb-radio-list [valueOnlyModel]="true" mode="image" name="channel_buttons_color"
					[(ngModel)]="channel.colorTheme" [options]="colorThemeOptions" [flexGrow]="false"
					(ngModelChange)="setThemeColors(channel.colorTheme)">
				</bb-radio-list>
			</bb-form-element>
		</div>

		<div class="input-with-color-picker">
			<!-- fontFamilyPrimary -->
			<mat-form-field appearance="fill" class="full-width">
				<mat-label>{{"FONT_PRIMARY" | translate}}</mat-label>
				<span matPrefix><i class="far fa-font-case"></i></span>
				<mat-select [(ngModel)]="channel.fontFamilyPrimary" name="channel_font_family_primary" [style.fontFamily]="channel.fontFamilyPrimary">
					<mat-option *ngFor="let font of fontFamilyOptions" [value]="font.value" [style.fontFamily]="font.value">
						{{ font.label }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<!-- primaryFontColor -->
			<mat-form-field appearance="fill" class="color-width">
				<bb-color-picker-box [(ngModel)]="channel.primaryFontColor" [pickerPosition]="'left'" [inMatFormField]="true"
					[excludeHexHash]="true" [hideLabel]="true" name="channel_primaryFontColor">
				</bb-color-picker-box>
			</mat-form-field>
		</div>

		<div class="input-with-color-picker">
			<!-- fontFamilySecondary -->
			<mat-form-field appearance="fill" class="full-width">
				<mat-label>{{"FONT_SECONDARY" | translate}}</mat-label>
				<span matPrefix><i class="far fa-font-case"></i></span>
				<mat-select [(ngModel)]="channel.fontFamilySecondary" name="channel_font_family_secondary" [style.fontFamily]="channel.fontFamilySecondary">
					<mat-option *ngFor="let font of fontFamilyOptions" [value]="font.value" [style.fontFamily]="font.value">
						{{ font.label }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<!-- secondaryFontColor -->
			<mat-form-field appearance="fill" class="color-width">
				<bb-color-picker-box [(ngModel)]="channel.secondaryFontColor" [pickerPosition]="'left'" [inMatFormField]="true"
					[excludeHexHash]="true" [hideLabel]="true" name="channel_secondaryFontColor">
				</bb-color-picker-box>
			</mat-form-field>
		</div>
		
		<div class="input-with-color-picker">
			<!-- backgroundColor (preset) -->
			<mat-form-field appearance="fill" class="full-width">
				<mat-label>{{"BACKGROUND_COLOR" | translate}}</mat-label>
				<span matPrefix><i class="far fa-fill-drip"></i></span>
				<mat-select [(ngModel)]="channel.backgroundColor" name="channel_backgroundColor">
					<mat-option *ngFor="let color of backgroundColorPreset" [value]="color.value">
						{{ color.label }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<!-- backgroundColor (picker) -->
			<mat-form-field appearance="fill" class="color-width">
				<bb-color-picker-box [(ngModel)]="channel.backgroundColor" [pickerPosition]="'left'" [inMatFormField]="true"
					[excludeHexHash]="true" [hideLabel]="true" name="channel_backgroundColor">
				</bb-color-picker-box>
			</mat-form-field>
		</div>

		<!-- borderRadius -->
		<mat-form-field appearance="fill" class="channel-input-number full-width">
			<span matPrefix><i class="far fa-border-top-left"></i></span>
			<mat-label>{{'BORDER_RADIUS' | translate}}</mat-label>
			<input type="number" min="0" [(ngModel)]="channel.borderRadius" matInput name="Channel_BorderRadius">
			<span matSuffix>px</span>
		</mat-form-field>

		<!-- pagePadding -->
		<mat-form-field appearance="fill" class="channel-input-number full-width">
			<span matPrefix><i class="far fa-border-outer"></i></span>
			<mat-label>{{'PADDING' | translate}}</mat-label>
			<input type="number" min="0" [(ngModel)]="channel.pagePadding" matInput name="Channel_PagePadding">
			<span matSuffix>px</span>
		</mat-form-field>

		<!-- maxWidth -->
		<mat-form-field appearance="fill" class="channel-input-number full-width">
			<span matPrefix><i class="far fa-left-right "></i></span>
			<mat-label>{{'MAXIMUM_WIDTH' | translate}}</mat-label>
			<input type="number" min="0" [(ngModel)]="channel.maxWidth" matInput name="maxWidth">
			<span matSuffix>px</span>
			<mat-hint>{{ 'HELP.CHANNELS_MAX_WIDTH' | translate }}</mat-hint>
		</mat-form-field>

		<h3>{{ 'PLAYER_OPTIONS' | translate }}</h3>
		<!-- playout -->
		<mat-form-field appearance="fill" class="full-width pointer">
			<mat-label>{{ 'PLAYOUT' | translate }}</mat-label>
			<bb-entity-selector theme="light-v2" [inMatFormField]="true" [disableClear]="true" [hideThumbnail]="true"
				[hideIcons]="true" [entityType]="'playout'" [(ngModel)]="channel.playout" name="channel_playout"
				placeholder="" [filterSet]="[{
					filters: [{
						type: 'playout',
						field: 'status',
						operator: 'isNot',
						value: 'inactive'
					}]
				}]"></bb-entity-selector>
		</mat-form-field>

		<!-- playIn -->
		<div class="channel-group-block">
			<bb-form-element [form]="form" [required]="true" theme="light-v2" [label]="'PLAYER_PLAY_IN' | translate"
				[hideRequiredMark]="true">
				<bb-radio-list [valueOnlyModel]="true" mode="image" name="channel_playIn"
					[(ngModel)]="channel.playIn" [options]="playerOptions" maxColumns="2">
				</bb-radio-list>
			</bb-form-element>
		</div>
	</div>
</div>
